module.exports = __webpack_public_path__ + "static/img/icon-3.7564760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/icon-3.png
// module id = larw
// module chunks = 0